import * as ssrActions from "../actions/AppStore";
import { SsrState, initialState } from "../store/SsrState";
import buildReducer from "../utils/ReducerBuilder";

export const SsrReducer = buildReducer<SsrState>(initialState)
    .handle(ssrActions.updateIsSsrFlag, (state, action) => {
        console.log("Updating isSSR flag");

        if (action.payload === undefined)
            return state;

        return {
            ...state,
            isSSR: action.payload,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/SsrReducer.ts